<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>设备品类</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters" ref="filtersForm">
          <el-form-item label="品类名称" prop="name">
            <el-input v-model="filters.name" placeholder="品类名称"></el-input>
          </el-form-item>
          <el-form-item label="品类编码" prop="code">
            <el-input v-model="filters.code" placeholder="品类编码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="resetForm('filtersForm')">重置</el-button>
            <el-button type="primary" @click="showAddDialog" v-has-permission="'device:category:add'">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table :data="deviceCategoryPageDatas" highlight-current-row border style="width: 100%;">
        <el-table-column type="index" width="60" align="center" fixed="left"></el-table-column>
        <el-table-column prop="name" label="品类名称" width="200" fixed="left" sortable></el-table-column>
        <el-table-column prop="code" label="品类编码" width="120" sortable></el-table-column>
        <el-table-column prop="template" label="品类模板" width="260" sortable></el-table-column>
        <el-table-column prop="sort" label="排序" width="120" sortable></el-table-column>
        <el-table-column prop="remark" label="备注" width="360" sortable></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="155" sortable></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="155" sortable></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)" v-has-permission="'device:category:update'">编辑</el-button>
            <el-button type="danger" size="mini" @click="remove(scope.$index,scope.row)" v-has-permission="'device:category:delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具栏-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="130px" :rules="formRules" ref="addForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="品类名称" prop="name">
                <el-input v-model.trim="addForm.name" placeholder="请输入内容" maxlength="30" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
             
            <el-col :span="12">
              <el-form-item label="品类编码" prop="code">
                <el-input v-model.trim="addForm.code" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="品类模板" prop="template">
                <el-input v-model="addForm.template" placeholder="请输入内容" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model.number="addForm.sort" placeholder="请输入内容" min="0" max="2147483647" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="大屏显示" prop="icon">
                <el-switch
                  v-model="addForm.screenShow">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="显示icon" prop="icon">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :on-change="addCategoryChange"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="addForm.iconUrl" :src="addForm.iconUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height:128px;"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="addForm.remark" :rows="3" placeholder="请输入内容" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="130px" :rules="formRules" ref="editForm">
          <el-input v-model="editForm.id" type="hidden"></el-input>
          <el-row>
            <el-col :span="12">
              <el-form-item label="品类名称" prop="name">
                <el-input v-model.trim="editForm.name" placeholder="请输入内容" maxlength="30" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
             
            <el-col :span="12">
              <el-form-item label="品类编码" prop="code">
                <el-input v-model.trim="editForm.code" placeholder="请输入内容" maxlength="40" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="品类模板" prop="template">
                <el-input v-model="editForm.template" placeholder="请输入内容" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model.number="editForm.sort" placeholder="请输入内容" min="0" max="2147483647" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="大屏显示" prop="icon">
                <el-switch
                  v-model="editForm.screenShow">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="显示icon" prop="icon">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :on-change="editCategoryChange"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="editForm.iconUrl" :src="editForm.iconUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height:128px;"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="editForm.remark" :rows="3" placeholder="请输入内容" maxlength="50" show-word-limit auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import DEVICE_API from '../../api/api_device';

export default {
  data() {
    let that = this;
    var checkCode = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入品类编码'));
        return;
      }
      var params = {
        code: value
      }
      if (that.editFormVisible) {
        params = Object.assign(params, {
          id: that.editForm.id
        });
      }
      DEVICE_API.checkDeviceCategoryCode(params)
      .then(
        function(result) {
          if (result && result.code == 200 
            && result.data && result.data === true) {
              callback(new Error('品类编码重复'));
              return;
          }
          callback();
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
          callback();
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
        callback();
      });
    };
    // 排序字段校验方法
    var checkSort = (rule, value, callback) => {
      if (value) {
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
          } else {
            if (value <= 0) {
              callback(new Error('输入数字必须大于等于0'));
            } else {
              callback();
            }
          }
        }, 1000);
      }
      // 清空排序字段时
      callback();
    };
    return {
      tempfile:null,
      loading: false,
      filters: {},
      // 分页参数
      total: 0,
      page: 1,
      limit: 10,
      deviceCategoryPageDatas: [],
      // 新增/编辑相关数据
      addFormVisible: false,//新增界面是否显示
      editFormVisible: false,//编辑界面是否显示
      addForm: {
        name:"",
        code:"",
        template:"",
        sort:"",
        screenShow:false,
        iconUrl:"",
        remark:""
      },
      editForm: {
        name:"",
        code:"",
        template:"",
        sort:"",
        screenShow:false,
        iconUrl:"",
        remark:""
      },
      formRules: {
        name:[
          {required: true, message: '请输入品类名称', trigger: ['blur','change']}
        ],
        code: [
          {required: true,validator: checkCode, trigger: ['blur','change']}
        ],
        template: [
          {required: true, message: '请输入品类模板', trigger: ['blur','change']}
        ],
        sort: [
          {validator: checkSort, trigger: ['blur','change']}
        ]
      }
    }
  },
  methods: {
      addCategoryChange:function(){
          var _this = this;
	        var event = event || window.event;
	        if(event.target.files){
		          var file = event.target.files['0'];
		          var reader = new FileReader();
		          reader.onload = function(e) {    //转base64
		            	_this.addForm.iconUrl = e.target.result
			            
              }
              _this.tempfile = file;
		          reader.readAsDataURL(file);
	        }
      },
      editCategoryChange:function(){
          var _this = this;
	        var event = event || window.event;
	        if(event.target.files){
              var file = event.target.files['0'];
		          var reader = new FileReader();
		          reader.onload = function(e) {    //转base64
		            	_this.editForm.iconUrl = e.target.result
			            
              }
              _this.tempfile = file;
		          reader.readAsDataURL(file);
          }
          console.log(this.editForm.iconUrl);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleSearch();
    },
    search() {
      let that = this;
      let params = Object.assign({
        page: that.page,
        limit: that.limit,
      }, that.filters);
      DEVICE_API.deviceCategoryPageList(params)
      .then(
        function(result){
          if (result && result.code == 200) {
            that.total = result.data.total;
            that.deviceCategoryPageDatas = result.data.records;
          }
        },
        function(error){
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    showAddDialog: function () {
      this.addFormVisible = true;
      this.tempfile=null;
    },
    //新增
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        const form = new FormData();
        form.append("category",that.tempfile==null?"":that.tempfile);
        
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.addForm);
          for(var i in params){
            form.append(i,params[i]);
          }
          DEVICE_API.saveDeviceCategory(form)
          .then(
            function(result){
              that.loading = false;
              if (result && result.code == 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '新增成功!',
                  duration: 2000
                });
                that.$refs['addForm'].resetFields();
                that.addForm.screenShow=false;
                that.addForm.iconUrl="";
                that.addFormVisible = false;
                that.handleSearch();
              } else {
                that.$message.error({
                  showClose: true,
                  message: '新增失败!',
                  duration: 2000
                });
              }
            },
            function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        }
      });
    },
    //显示编辑界面
    showEditDialog: function (index, row) {
      this.editFormVisible = true;
      this.tempfile=null;
      //避免源对象row被修改
      var newRow = JSON.parse(JSON.stringify(row));
      this.editForm = Object.assign({}, newRow);
      console.log(this.editForm);
    },
    //编辑
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        const form = new FormData();
        form.append("category",that.tempfile);
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.editForm);
          for(var i in params){
            form.append(i,params[i]);
          }
          DEVICE_API.updateDeviceCategory(form)
          .then(
            function(result){
              that.loading = false;
              if (result && result.code == 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '修改成功!',
                  duration: 2000
                });
                that.$refs['editForm'].resetFields();
                that.editForm.screenShow=false;
                that.editForm.iconUrl="";
                that.editFormVisible = false;
                that.handleSearch();
              } else {
                that.$message.error({
                  showClose: true,
                  message: '修改失败!',
                  duration: 2000
                });
              }
            },
            function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        }
      });
    },
    //删除
    remove: function (index, row) {
      let that = this;
      this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
        that.loading = true;
        DEVICE_API.removeDeviceCategory(row.id)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.code === 200 
              && result.data && result.data === true) {
              that.$message.success({
                showClose: true,
                message: '删除成功',
                duration: 1500
              });
              that.search();
            }
          }, 
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
        })
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      }).catch(() => {
      });
    }

  },
  mounted() {
    this.handleSearch();
  }
};
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }
  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// deviceCategory.vue?056a9b10